export const STATUS_FETCH_REPORTING_PERIODS_BEGIN = 'STATUS_FETCH_REPORTING_PERIODS_BEGIN';
export const STATUS_FETCH_REPORTING_PERIODS_SUCCESS = 'STATUS_FETCH_REPORTING_PERIODS_SUCCESS';
export const STATUS_FETCH_REPORTING_PERIODS_FAILURE = 'STATUS_FETCH_REPORTING_PERIODS_FAILURE';
export const STATUS_FETCH_REPORTING_PERIODS_DISMISS_ERROR = 'STATUS_FETCH_REPORTING_PERIODS_DISMISS_ERROR';
export const STATUS_FETCH_CONTROL_ACCOUNTS_BEGIN = 'STATUS_FETCH_CONTROL_ACCOUNTS_BEGIN';
export const STATUS_FETCH_CONTROL_ACCOUNTS_SUCCESS = 'STATUS_FETCH_CONTROL_ACCOUNTS_SUCCESS';
export const STATUS_FETCH_CONTROL_ACCOUNTS_FAILURE = 'STATUS_FETCH_CONTROL_ACCOUNTS_FAILURE';
export const STATUS_FETCH_CONTROL_ACCOUNTS_DISMISS_ERROR = 'STATUS_FETCH_CONTROL_ACCOUNTS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/status/redux/constants.js